import {
  Backdrop,
  Badge,
  Box,
  Button,
  CircularProgress,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  ExportCsv,
  ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
  GridViewColumnIcon,
  GridFilterListIcon,
} from "@mui/x-data-grid";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DataContext } from ".";
import styled from "@emotion/styled";
import { Cancel, ClearOutlined, FileDownload, Search } from "@mui/icons-material";
import toast from "react-hot-toast";
import ComponentBackdrop from "../../components/backdrop";
import CustomTheme from "../../theme/customTheme";
import { useApiClient } from "../../context/ApiClientContext";
import api from '../../helper/baseApi';
import { valueTagsList } from "../../data/valueTagData";
import SuccessAlert from "../../helper/successAlert";
import ErrorAlert from "../../helper/errorAlert";
import { Swiper, SwiperSlide, useSwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import { Card, CardContent } from "@mui/material";
import { valueTagData } from "../../data/valueTag";
import ConfirmDialog from "../../helper/confirmDialog";

const StyledQuickFilter = styled(QuickFilter)({
  display: "grid",
  alignItems: "center",
});

const StyledToolbarButton = styled(ToolbarButton)(({ theme, ownerState }) => ({
  gridArea: "1 / 1",
  width: "min-content",
  height: "min-content",
  zIndex: 1,
  opacity: ownerState.expanded ? 0 : 1,
  pointerEvents: ownerState.expanded ? "none" : "auto",
  transition: theme.transitions.create(["opacity"]),
}));

const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
  gridArea: "1 / 1",
  overflowX: "clip",
  width: ownerState.expanded ? 260 : "var(--trigger-width)",
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(["width", "opacity"]),
}));

function CustomToolbar({ onAdd, showButton, openConfirm, handleOpenConfirm, handleDelete, handleCloseConfirm, selectedRows, rows, isMobile, allowAdd, headerId }) {
  const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  const exportMenuTriggerRef = React.useRef(null);


  return (
    <>
      <Toolbar>
        <Button
          variant="contained"
          size="medium"
          disabled={!headerId}
          sx={{ width: 120, backgroundColor: "#FFD166", fontWeight: "bold" }} // fixed width
          onClick={onAdd}
        >
          Add
        </Button>
        {showButton && (
          <>
            <Button
              variant="contained"
              size="medium"
              fullWidth={isMobile}
              sx={{
                mx: 1,
                width: 120,
                backgroundColor: "secondary.main",
                fontWeight: "600",
                "&:hover": { backgroundColor: "secondary.dark" },
                whiteSpace: "nowrap",
              }}
              onClick={handleOpenConfirm}
            >
              Delete
            </Button>
          </>
        )}

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        onConfirm={handleDelete}
        title="Delete Department"
        message={`Are you sure you want to delete ${selectedRows.length > 1 ? "these departments" : "this department"
          }?`}
        items={rows
          .filter(item => selectedRows.includes(item.valueTagId))
          .map(item => item.name)}
        confirmText="Delete"
        confirmColor="error"
      />

        <Box sx={{ flexGrow: 1 }} />

        <Tooltip title="Columns">
          <ColumnsPanelTrigger render={<ToolbarButton />}>
            <GridViewColumnIcon fontSize="small" />
          </ColumnsPanelTrigger>
        </Tooltip>

        <Tooltip title="Filters">
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props} color="default">
                <Badge
                  badgeContent={state.filterCount}
                  color="primary"
                  variant="dot"
                >
                  <GridFilterListIcon fontSize="small" />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>

        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ mx: 0.5 }}
        />
        {/* <Tooltip title="Export">
          <ToolbarButton
            ref={exportMenuTriggerRef}
            id="export-menu-trigger"
            aria-controls="export-menu"
            aria-haspopup="true"
            aria-expanded={exportMenuOpen ? "true" : undefined}
            onClick={() => setExportMenuOpen(true)}
          >
            <FileDownload fontSize="small" />
          </ToolbarButton>
        </Tooltip> */}

        {/* <Menu
          id="export-menu"
          anchorEl={exportMenuTriggerRef.current}
          // open={exportMenuOpen}
          onClose={() => setExportMenuOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          slotProps={{
            list: {
              "aria-labelledby": "export-menu-trigger",
            },
          }}
        >
          {/* <ExportPrint
            render={<MenuItem />}
            onClick={() => setExportMenuOpen(false)}
          >
            Print
          </ExportPrint>
          <ExportCsv
            render={<MenuItem />}
            onClick={() => setExportMenuOpen(false)}
          >
            Download as CSV
          </ExportCsv> */}
        {/* </Menu> */}

        <StyledQuickFilter>
          <QuickFilterTrigger
            render={(triggerProps, state) => (
              <Tooltip title="Search" enterDelay={0}>
                <StyledToolbarButton
                  {...triggerProps}
                  ownerState={{ expanded: state.expanded }}
                  color="default"
                  aria-disabled={state.expanded}
                >
                  <Search fontSize="small" />
                </StyledToolbarButton>
              </Tooltip>
            )}
          />
          <QuickFilterControl
            render={({ ref, ...controlProps }, state) => (
              <StyledTextField
                {...controlProps}
                ownerState={{ expanded: state.expanded }}
                inputRef={ref}
                aria-label="Search"
                placeholder="Search..."
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: state.value ? (
                      <InputAdornment position="end">
                        <QuickFilterClear
                          edge="end"
                          size="small"
                          aria-label="Clear search"
                          material={{ sx: { marginRight: -0.75 } }}
                        >
                          <Cancel fontSize="small" />
                        </QuickFilterClear>
                      </InputAdornment>
                    ) : null,
                    ...controlProps.slotProps?.input,
                  },
                  ...controlProps.slotProps,
                }}
              />
            )}
          />
        </StyledQuickFilter>
      </Toolbar>
    </>
  );
}

function ValueTagCard({ tag }) {
  const slide = useSwiperSlide();
  const isActive = slide.isActive;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        px: { xs: 1, sm: 2 },
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: { xs: 180, sm: 220, md: 260 },
          px: 2,
          py: 1.5,
          textAlign: "center",
          minHeight: { xs: 120, sm: 160, md: 140 },
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: isActive ? "flex-start" : "center",
          alignItems: "center",
          backgroundColor: isActive ? "#FFD166" : "#EAEBDC",
          borderRadius: 3,
          transition: "all 0.3s ease-in-out",
          transform: isActive ? "scale(1.08)" : "scale(0.95)",
          mt: isActive ? 2 : 3,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Typography
            variant="subtitle"
            gutterBottom
            sx={{
              textTransform: "uppercase",
              color: "#8C8C8C",
              mt: isActive ? 2 : 3,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {tag.name}
          </Typography>

          {isActive && tag.description && (
            <Typography
              variant="body"
              sx={{ mt: 0.5, textAlign: "center" }}
            >
              {tag.description}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

const ValueTagList = ({ valueTagSet, allowAdd, headerId, handleShowButton, onRefetch }) => {
  const labelWidth = 100;
  console.log('headerId', headerId);

  const rows = valueTagSet || [];
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [iconOptions, setIconOptions] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    iconCode: "lni lni-arm-flex", // default thumbs-up icon
    passRate: "70",      // default pass rate
    distributeRate: "50" // default average
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [mode, setMode] = useState('view');
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one department to delete.");
      return;
    }
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);

  const [userUsage, setUserUsage] = useState({
    isSetPassRate: false,
    isSetDistributedRate: false,
  });

  const handleOpenModal = (mode) => {
    setMode(mode);

    if (mode === "edit" && rows) {
      setSelectedRow(rows);
      setFormData({
        name: rows.name || "",
        description: rows.description || "",
        iconCode: rows.iconCode || "lni lni-arm-flex",
        passRate: rows.passRate?.toString() || "0",
        distributeRate: rows.distributeRate?.toString() || "0",
      });
    } else {
      // reset for add mode
      setSelectedRow(null);
      setFormData({
        name: "",
        description: "",
        iconCode: "lni lni-arm-flex",
        passRate: "0",
        distributeRate: "0",
      });
    }
    checkUser();

    setOpenModal(true);
  };

  const checkUser = async () => {
    const apiUrl = `${mobileApiUrl}usage/check-usage`;
    const response = await api.get(apiUrl);

    if (response.status === 200 && response.data) {
      console.log(response.data);

      setUserUsage({
        isSetPassRate: response.data.isSetPassRate,
        isSetDistributedRate: response.data.isSetDistributedRate,
      });
    }
  };

  const handleCloseModal = () => setOpenModal(false);
  function parseLineIconClasses(cssText) {
    const re = /\.lni-([a-z0-9-]+)\s*::?before/g;
    const names = new Set();
    let m;
    while ((m = re.exec(cssText)) !== null) {
      names.add(`lni-${m[1]}`);
    }
    return Array.from(names);
  }

  const handleDelete = async (ids) => {
    setOpenBackdrop(true);
    try {
      const apiUrl = `${mobileApiUrl}valueTag/delete-vt`;
      const response = await api.delete(apiUrl, {
        data: { valueTagIds: selectedIds },
      });
       if (response.status === 200) {
        const deletedItems = rows.filter(item =>
          selectedIds.includes(item.valueTagId)
        );
        const deletedNames = deletedItems.map(item => item.name);
        
        setTimeout(() => {
          toast.success(`Deleted: ${deletedNames.join(", ")}`);
          if (onRefetch) onRefetch();

          setSelectedIds([]);
        
          setOpenConfirm(false);
          setOpenBackdrop(false);
        }, 2000);

        } else {
          toast.error("Failed to delete departments. Please try again.");
        }
    } catch (error) {
      setTimeout(() => {
        ErrorAlert(error, navigate);
      }, 2000);
    } finally {
      setTimeout(() => {
        setOpenBackdrop(false);
        setSelectedIds([]);
        handleShowButton(false);
      }, 2000);
    }
  };

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === "include") {
      selectedIds = Array.from(id.ids);
    } else if (id.type === "exclude") {
      const excluded = new Set(id.ids);
      selectedIds = rows
        .filter((row) => !excluded.has(row.valueTagId)) // 👈 must use valueTagId here
        .map((row) => row.valueTagId);
    }

    console.log("selectCheckBox:", selectedIds);
    setSelectedIds(selectedIds);
    setShowButton(selectedIds.length > 0);
  };

  const {
    apiUrls: { mobileApiUrl },
  } = useApiClient();


  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/icons.css");
        const css = await res.text();
        const classes = parseLineIconClasses(css);
        const options = classes.map((c) => ({
          value: `lni ${c}`,   // "lni lni-home"
          label: c.replace("lni-", "")
        }));
        setIconOptions(options);
      } catch (e) {
        console.error("Failed to load /icons.css", e);
      }
    })();
  }, [openModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const renderField = (
    label,
    id,
    type = "text",
    select = false,
    options = [],
    disabled = false
  ) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
        }}
      >
        {label}
      </Typography>
      <TextField
        id={id}
        name={id}
        type={type}
        select={select}
        disabled={disabled}
        error={!!errors[id]}
        helperText={errors[id]}
        onChange={handleChange}
        value={formData[id]}
        required
        fullWidth
        size="small"
        variant="outlined"
        inputProps={id === "name" ? { maxLength: 15 } : {}}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 230, // limit height
              },
            },
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
          },
          renderValue: (selected) =>
            selected ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <i className={selected} style={{ marginRight: 8 }} />
                {selected.replace("lni lni-", "")}
              </Box>
            ) : (
              <em>Select an icon</em>
            ),
        }}
      >
        {iconOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            <i className={opt.value} style={{ marginRight: 8 }} />
            {opt.label}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );

  const handleSave = async (mode, data) => {
    // 🔹 reset errors
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = "Name is required.";
    }
    if (!formData.description?.trim()) {
      newErrors.description = "Description is required.";
    }

    // if we have validation errors, stop here
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      setOpenBackdrop(true);

      let response = '';
      let apiUrl = '';

      if (mode === 'edit') {
        apiUrl = `${mobileApiUrl}valueTag/update-vt-details`;
        response = await api.put(apiUrl, {
          valueTagId: selectedRow?.valueTagId,
          name: formData.name,
          description: formData.description,
          iconCode: formData.iconCode,
          passRate: formData.passRate,
          distributeRate: formData.distributeRate,
        });
      }
      else {
        apiUrl = `${mobileApiUrl}valueTag/create-valuetag`;
        response = await api.post(apiUrl, {
          valueTagHeaderId: headerId,
          name: formData.name,
          description: formData.description,
          iconCode: formData.iconCode,
          passRate: formData.passRate,
          distributeRate: formData.distributeRate,
        });
      }

      if (response.status == 200) {
        setTimeout(() => {
          setOpenBackdrop(false);
          handleCloseModal(true)
          SuccessAlert(response.data.message);

          if (onRefetch) onRefetch();
        }, 2000);
      }
    }
    catch (error) {
      setOpenBackdrop(false);
      handleCloseModal(true)
      const apiErrors = error?.response?.data?.errors;

      if (
        Array.isArray(apiErrors) &&
        apiErrors.some(err => err.includes("ValueTag quota exceeded"))
      ) {
        toast.error("Limit reached: Upgrade plan to add more Value Tags.");
      } else {
        ErrorAlert(error, navigate);
      }
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 80,
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            style={{
              fontWeight: "bold",
              color: "black",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setMode("edit");
              setSelectedRow(params.row);

              setFormData({
                name: params.row.name || "",
                description: params.row.description || "",
                iconCode: params.row.iconCode?.startsWith("lni")
                  ? params.row.iconCode
                  : `lni lni-${params.row.iconCode || "arm-flex"}`,
                passRate: params.row.passRate?.toString() || "70",
                distributeRate: params.row.distributeRate?.toString() || "50",
              });
              setOpenModal(true);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 150,
      flex: 1,
    },
    {
      field: "iconCode",
      headerName: "Icon",
      width: 150,
      renderCell: (params) => {
        const iconClass = params.row.iconCode?.startsWith("lni")
          ? params.row.iconCode
          : `lni lni-${params.row.iconCode}`;
        return <i className={iconClass} style={{ fontSize: 20 }} />;
      },
    },
    {
      field: "passRate",
      headerName: "Pass Rate",
      width: 120,
    },
    {
      field: "distributeRate",
      headerName: "Weightage",
      width: 150,
    },
  ];
  return (
    <Box sx={{ width: "100%", px: { xs: 2, sm: 3, md: 3 } }}>
      <ComponentBackdrop openBackdrop={openBackdrop} />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="md"
        keepMounted
      >
        <DialogTitle>{mode === "edit" ? `Edit Value Tag - ${selectedRow?.valueTagId}` : "Add Value Tag"}</DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 6 }}
          >
            <Grid size={{ xs: 12 }}>
              {renderField("Name", "name", "text", false, [])}
              {renderField("Description", "description", "text", false, [])}
              {renderField("Icon", "iconCode", "select", true, iconOptions)}
              {/* Disable if isSetPassRate is false */}
              {renderField(
                "Pass Rate",
                "passRate",
                "number",
                false,
                [],
                !userUsage.isSetPassRate
              )}

              {/* Disable if isSetDistributedRate is false */}
              {renderField(
                "Weightage",
                "distributeRate",
                "number",
                false,
                [],
                !userUsage.isSetDistributedRate
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={handleCloseModal}
            variant="text"
            sx={{ color: "#000" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSave(mode, formData)}
            variant="contained"
            sx={{ backgroundColor: "#FFD166", fontWeight: "bold" }}
          >
            {mode === "edit" ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* carousel */}
      <Box
        sx={{
          width: { xs: "100%", sm: "90%", md: "100%" },
          mx: "auto",
          mb: 4,
          position: "relative",

          // ✅ style arrows globally
          "& .swiper-button-next, & .swiper-button-prev": {
            color: "#39493F",
            top: "50%",
            transform: "translateY(50%)",
            zIndex: 20,
            width: 32,
            height: 32,
          },
          "& .swiper-button-prev": {
            left: { xs: -8, sm: -8, md: -25, lg: -8 }, // ✅ always OUTSIDE container
          },
          "& .swiper-button-next": {
            right: { xs: -8, sm: -8, md: -55, lg: -8 },
          },
        }}
      >
        <Swiper
          grabCursor
          centeredSlides
          loop
          navigation
          modules={[Navigation]}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 20 },
            900: { slidesPerView: 2, spaceBetween: 24 },
            1200: { slidesPerView: 3, spaceBetween: 28 },
          }}
        >
          {valueTagData.map((tag) => (
            <SwiperSlide key={tag.valueTagId}>
              {({ isActive }) => (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Card
                    sx={{
                      width: { xs: 200, sm: 220, md: 230 },  // ✅ fixed card size
                      height: { xs: 140, sm: 160, md: 150, lg: 140 }, // ✅ fixed height
                      px: 2,
                      py: 1.5,
                      textAlign: "center",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: isActive ? "flex-start" : "center",
                      alignItems: "center",
                      backgroundColor: isActive ? "#FFD166" : "#EAEBDC",
                      borderRadius: 3,
                      transition: "all 0.3s ease-in-out",
                      transform: isActive ? "scale(1.08)" : "scale(0.95)",
                      mt: isActive ? 1 : 2,
                    }}
                  >
                    <CardContent sx={{ p: 0, mt: 2 }}>
                      <Typography
                        variant="subtitle"
                        gutterBottom
                        sx={{
                          textTransform: "uppercase",
                          color: "#8C8C8C",
                          mt: isActive ? 2 : 3,
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        {tag.name}
                      </Typography><p/>

                      {isActive && tag.description && (
                        <Typography
                          variant="body"
                          sx={{ mt: 0.5, textAlign: "center" }}
                          noWrap={false}
                        >
                          {tag.description}
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Box>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>


      {/* <ThemeProvider theme={CustomTheme}> */}
      <div style={{ height: 370, width: "100%" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          getRowId={(row) => row.valueTagId}
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          pageSizeOptions={[5, 10, { value: 50, label: "50" }]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 },
            },
            sorting: { sortModel: [{ field: "passRate", sort: 'desc' }] }
          }}
          checkboxSelection
          onRowSelectionModelChange={(id) => {
            onSelectedCheckbox(id, rows);
          }}
          disableRowSelectionOnClick
          localeText={{ noRowsLabel: "No records found" }}
          slotProps={{
            toolbar: {
              onAdd: handleOpenModal,
              showButton,
              openConfirm,
              handleOpenConfirm,
              handleDelete,
              handleCloseConfirm,
              rowSelectionModel: { selectedIds },
              selectedRows: selectedIds,
              rows,
              isMobile: false,
              headerId,
            },
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true",
            },
          }}
        />
      </div>
      {/* </ThemeProvider> */}
    </Box>
  );
};

export default ValueTagList;